module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "pz11-1"
    }
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct12",
    attrs: {
      "id": "pz11-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#bb_02",
      "id": "aa_02"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz11-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter03#bb_03",
      "id": "aa_03"
    }
  }, [_vm._v("ONE: Wrong Church, Wrong People, Wrong Day")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz11-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter04#bb_04",
      "id": "aa_04"
    }
  }, [_vm._v("TWO: Forgiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz11-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#bb_05",
      "id": "aa_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THREE: The Flag Comes Down")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz11-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#bb_06",
      "id": "aa_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FOUR: The Sin of Slavery")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz11-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#bb_07",
      "id": "aa_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIVE: Revolutionary Ideas and the Rise of African Methodism")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz11-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#bb_08",
      "id": "aa_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIX: The Slave Conspiracy")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz11-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#bb_09",
      "id": "aa_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEVEN: Resurrection")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz11-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#bb_10",
      "id": "aa_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EIGHT: Jim Crow")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz11-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#bb_11",
      "id": "aa_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NINE: Life in the Borough")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz11-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#bb_12",
      "id": "aa_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEN: Civil Rights")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz11-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#bb_13",
      "id": "aa_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ELEVEN: People in Service to the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz11-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#bb_14",
      "id": "aa_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWELVE: What Is Forgiveness?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz11-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#bb_15",
      "id": "aa_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIRTEEN: The Unfinished Story")])]), _vm._v(" "), _c('p', {
    staticClass: "cct11",
    attrs: {
      "id": "pz11-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#bb_16",
      "id": "aa_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz11-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#bb_17",
      "id": "aa_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz11-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#bb_18",
      "id": "aa_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz11-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#bb_19",
      "id": "aa_19",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Authors")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz11-20a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#bb_20",
      "id": "aa_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Photos")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0